import useWindowDimensions from '@hooks/useWindowDimensions'
import { JoinEdugram1, JoinEdugram2 } from '@public/static/icons/join-edugram'
import {
  BenefitsForCreatorsHeader,
  BenefitsForCreatorsSubHeader,
  BenefitsForCreatorsWrapper,
  JoinEdugramInnerWrappery,
  JoinEdugramWrapper,
  JoinUsButtonBenefits,
} from '@styled_components/home/styled.components'
import Link from 'next/link'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {}

const JoinUs = ({}: Props) => {
  const { width } = useWindowDimensions()
  const { t } = useTranslation(['landingPage'])
  const [wrapperHeight, setWrapperHeight] = useState(0)
  const divRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleResize() {
      if (divRef.current) {
        const joinEdugramWrapperHeight = divRef.current?.clientHeight
        setWrapperHeight(joinEdugramWrapperHeight)
      } else {
        setWrapperHeight(0)
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize() // Call it initially

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div>
      <JoinEdugramWrapper
        ref={divRef}
        className="absolute w-[100%] left-0 !m-0 !mt-0"
      >
        <JoinEdugramInnerWrappery>
          {(width || 0) < 800 || (
            <div
              style={{
                flex: 1,
                paddingLeft: 15,
                alignSelf: 'flex-end',
                marginBottom: -10,
              }}
            >
              <JoinEdugram1></JoinEdugram1>
            </div>
          )}

          <BenefitsForCreatorsWrapper
            style={{
              background: 0,
              padding: '30px 10px',
              textAlign: 'center',
              flex: 2,
              margin: 0,
              zIndex: 0,
            }}
          >
            <BenefitsForCreatorsHeader className="mb-4">
              {t('joinEdugram', { ns: 'landingPage' })}
            </BenefitsForCreatorsHeader>
            <BenefitsForCreatorsSubHeader>
              {t('joinEdugramSlogan', { ns: 'landingPage' })}
            </BenefitsForCreatorsSubHeader>

            <Link href="/author/become-author">
              <JoinUsButtonBenefits>
                {t('becomeAuthor', { ns: 'landingPage' })}
              </JoinUsButtonBenefits>
            </Link>
          </BenefitsForCreatorsWrapper>
          {(width || 0) < 800 || (
            <div
              style={{
                flex: 1,
                paddingRight: 15,
                marginBottom: -10,
                textAlign: 'right',
                alignSelf: 'center',
              }}
            >
              <JoinEdugram2></JoinEdugram2>
            </div>
          )}
        </JoinEdugramInnerWrappery>
      </JoinEdugramWrapper>
      <div style={{ height: `${wrapperHeight}px` }} />
    </div>
  )
}

export default JoinUs
